import { Document, Folder, Identifiable } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function updateDocument(httpClient: HttpClient) {
  return (
    namespace: string,
    type: string,
    folder: Identifiable<Folder>,
    document: Identifiable<Document>,
  ) =>
    httpClient.sendHttpRequest<Identifiable<Document>>({
      endpoint: `/api/documents/${document.uuid}`,
      method: HttpMethods.PATCH,
      data: {
        name: document.name,
      },
    });
}

export { updateDocument };
